import { tenantSelector } from '@/features/configuration/configurationSelector';
import { createSelector, selector } from '@/store/utils';
import { getTenantConfiguration } from '@/utils/tenant';

export const enableMapComponentSelector = selector(
  (state) =>
    getTenantConfiguration(tenantSelector(state).value)?.enableMapComponent ??
    false
);

const selectIsMapLoaded = selector((state) => state.mapComponent.isMapLoaded);
export const isMapLoadedSelector = createSelector(selectIsMapLoaded);

const selectIsMapOpen = selector((state) => state.mapComponent.isMapOpen);
export const isMapOpenSelector = createSelector(selectIsMapOpen);

const selectJourney = selector((state) => state.mapComponent.journey);
export const mapJourneySelector = createSelector(selectJourney);
